// Header.jsx
import React from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import "./CheckInLanding.css";
import Logo from "../../assets/checkinimg/logo.png";

const navItems = [
    { label: "Home", href: "#Home" },
    { label: "About Us", href: "#About Us" },
    { label: "How it works", href: "#how-it-works" },
    { label: "Pricing", href: "#pricing" },
    { label: "FAQ", href: "#faq" },
];

const Header = () => {
    return (
        <Navbar expand="lg" className="custom-headers sticky-top">
            <Container className="header-container">
                <Navbar.Brand href="/" className="header-logo">
                    <img src={Logo} />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="main-navbar" />

                <Navbar.Collapse id="main-navbar" className="justify-content-center">
                    <Nav className="gap-md-4">
                        {navItems.map((item) => (
                            <Nav.Link key={item.label} href={item.href} className="nav-link-custom">
                                {item.label}
                            </Nav.Link>
                        ))}

                    </Nav>
                    <Button className="signup-btn d-block d-lg-none">Sign Up</Button>
                </Navbar.Collapse>

                <Button className="signup-btn d-none d-lg-block">Sign Up</Button>
            </Container>
        </Navbar>
    );
};

export default Header;